import React, { useCallback, useEffect } from 'react'
import { moduleContext } from 'react-contextual'
import { get } from 'lodash-es'
import { useDispatch, useSelector } from 'react-redux'
import { reconApiEvents, reconApiSelectors } from '../../../../../api/recon'
import { invoiceApiEvents, invoiceApiSelectors } from 'modules/api/invoice'
import { walletApiSelectors } from 'modules/api/wallet'
import { useEffectOnce } from 'react-use'
interface ActiveInvoicesProviderProps {
  customerId: string
  accountId: string
  isConsolidatedBalance: boolean
}

const ActiveInvoicesProvider = moduleContext()(
  ({ context, children, ...props }: ActiveInvoicesProviderProps & { context: any; children: React.ReactNode }) => {
    const { customerId, accountId, isConsolidatedBalance } = props
    const dispatch = useDispatch()

    const fetchInvoiceTypes = useCallback(() => dispatch(invoiceApiEvents.invoiceTypes_request()), [dispatch])

    useEffectOnce(() => {
      fetchInvoiceTypes()
    })

    useEffect(() => {
      dispatch(reconApiEvents.customerActiveInvoices_request({ customerId, accountId }))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId, accountId])

    const customerSummary = useSelector(state => reconApiSelectors.getCustomerSummary(state)(customerId, accountId))
    const consolidatedBalance = useSelector(state => walletApiSelectors.getConsolidatedBalance(state)(customerId))

    const activeInvoicesStore = {
      // The per-account summary (customerAccountActivity) is only fetched for real accounts; for the
      // synthetic consolidated account it never loads, so its available funds come from the wallet's
      // consolidatedBalance instead.
      availableFunds: isConsolidatedBalance ? consolidatedBalance : get(customerSummary, 'availableFunds', 0),
      fetchInvoiceTypes,
      invoiceTypes: useSelector(state => invoiceApiSelectors.getInvoiceTypes(state)),
      activeInvoices: useSelector(state =>
        reconApiSelectors.getCustomerActiveInvoicesByAccount(state)(customerId, accountId),
      ),
    }

    return <context.Provider value={activeInvoicesStore}>{children}</context.Provider>
  },
)

export default ActiveInvoicesProvider
